import API from "../api/index";

export const fetchPartner = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem("token");
      console.log("token", token);

      if (
        !token &&
        window.location.pathname !== "/login" &&
        window.location.pathname !== "/register"
      ) {
        window.location.href = "/login";
        return resolve();
      } else if (!token) {
        return resolve();
      }
      const res = await API("/partner/partner-info", "GET").catch((err) => {
        return resolve();
      });
      if (res) {
        if (
          window.location.pathname === "/login" ||
          window.location.pathname === "/register"
        ) {
          window.location.href = "/";
          return resolve();
        }

        return resolve(res);
      }
    } catch (err) {
      window.location.href = "/login";
      return resolve();
    }
  });
};
